// import i18n from 'i18next'
// import { initReactI18next } from 'react-i18next'
// import LanguageDetector from 'i18next-browser-languagedetector'

// import ar from './locales/ar.json'
// import en from './locales/en.json'

// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     resources: {
//       ar: { translation: ar },
//       en: { translation: en },
//     },
//     lng: 'en',
//     fallbackLng: 'en',
//     interpolation: { escapeValue: false },
//   })

// export default i18n










import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import ar from './locales/ar.json'
import en from './locales/en.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    // متسيبش lng متحدد هنا - لو حاططها، الـ LanguageDetector هيتعطل خالص
    // وهيفضل شايل نفس اللغة اللي حاططها هنا لغاية ما تنادي i18n.changeLanguage يدوي
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  })

export default i18n